import { useEffect } from 'react';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Drawer, Divider } from '@mui/material';
import CustomerItem from './primaryMenu/CustomerItem';
import SalesItem from './primaryMenu/SalesItem';
import ReportItem from './primaryMenu/ReportItem';
import HelpItem from './primaryMenu/HelpItem';
import AdminItem from './primaryMenu/AdminItem';

interface GlobalSidebarNavProps {
  onMobileClose: () => void;
  openMobile: boolean;
}

const GlobalSidebarNav: FC<React.PropsWithChildren<GlobalSidebarNavProps>> = (props) => {
  const { onMobileClose, openMobile } = props;
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
      className="global-sidebar"
    >
      <Box className="global-sidebar__menu">
        <>
          <Box className="global-sidebar__menu__item">
            <CustomerItem onCloseNav={onMobileClose} />
          </Box>
          <Divider sx={{ my: 3 }} />
          <Box className="global-sidebar__menu__item">
            <SalesItem />
          </Box>
          <Divider sx={{ my: 3 }} />
          <Box className="global-sidebar__menu__item">
            <ReportItem />
          </Box>
          <Divider sx={{ my: 3 }} />
          <Box className="global-sidebar__menu__item">
            <HelpItem />
          </Box>
          <Divider sx={{ my: 3 }} />
          <Box className="global-sidebar__menu__item">
            <AdminItem />
          </Box>
        </>
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={openMobile}
      PaperProps={{
        sx: {
          backgroundColor: 'background.paper',
          width: 315,
        },
      }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};

export default GlobalSidebarNav;
